import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Link, withRouter, Redirect } from 'react-router-dom';
import Button from './Button';
import SuccessMessage from './SuccessMessage';
import ErrorMessage from './ErrorMessage';
import {
  getQuizID,
  getQuizSections,
  getQuestion,
  getAnswers,
  getQuizSectionIndex,
  getQuestionID,
  getQuestionNumber,
  getSectionName,
  getNextLinkTo,
  getUserUID,
  getUserAnswer,
  currentUserNumberQuestionsAnswered,
  totalNumberQuestions,
} from '../selectors';

class QuestionForm extends Component {
  componentDidUpdate(prevProps) {
    const { questionID, form } = this.props;
    if (questionID !== prevProps.questionID) {
      form.reset();
    }
  }

  render() {
    const {
      showOfflineMessage,
      handleSubmit,
      dirty,
      submitSucceeded,
      submitFailed,
      submitting,
      question: {
        correctAnswer,
        successMessage,
        title,
        answers,
        userAnswer,
        userHasAnswered,
      },
      sectionIndex,
      sectionName,
      questionNumber,
      nextLinkTo,
      numberOfQuestionsAnswered,
      totalNumberQuestions,
    } = this.props;

    if ((submitSucceeded || submitFailed) && (numberOfQuestionsAnswered === totalNumberQuestions)) {
      return <Redirect to="/quiz/survey" push />;
    }

    return (
      <div className="Question mw-100 mw7-ns w-100 center">
        {/* TODO we should move this into the overall app header, right now it's just position: absolute  */}
        <div className="Question-header fixed h3 w-100 flex items-center bb b--light-gray bg-white">
          <div className="flex items-center justify-between mw-100 mw7-ns w-100 center">
            <div className="pl3">
              {/* TODO it would be cool if this back button ended up being contextual? */}
              <Link to="/quiz">
                <i className="material-icons">arrow_back</i>
              </Link>
            </div>
            <div className="Question-header-title tc lh-solid">
              <h1 className="f5 b lh-solid">
                Question
                {' '}
                {questionNumber + 1}
              </h1>
              <span className="f7 moon-gray">{sectionName}</span>
            </div>
            <div className="Question-index pr3">
              <Link to={`/quiz/${sectionIndex}`}><i className="material-icons">format_list_numbered</i></Link>
            </div>
          </div>
        </div>
        <div className="Question-content pb4 bg-white">
          {showOfflineMessage && (
            <div className="Question-content-offline">
              Bad connection. Don't worry, we'll save your answer. If you're connected to WiFi, try using your mobile data. <strong>Attempting to reconnect...</strong>
            </div>
          )}
          <form onSubmit={handleSubmit}>
            {/* TODO Make nagivation for Next Buttons work  */}
            {(userAnswer === correctAnswer) && (
              <SuccessMessage>
                <div className="check flex items-start justify-between w-100">
                  <div className="w-70 b">{successMessage}</div>
                  <Link to={nextLinkTo} className="Button-small b" style={{ backgroundColor: '#50d400', color: '#fff' }}>Next</Link>
                </div>
              </SuccessMessage>
            )}
            {((!isEmpty(userAnswer)) && (userAnswer !== correctAnswer)) && (
              <ErrorMessage>
                <div className="check flex items-start justify-between w-100">
                  <div className="w-70 b">{successMessage}</div>
                  <Link to={nextLinkTo} className="Button-small b" style={{ backgroundColor: '#e65932', color: '#fff' }}>Next</Link>
                </div>
              </ErrorMessage>
            )}
            <p className="Question-title pa3">{title}</p>
            <ul className="Question-answers list ph3">
              {answers.map(answer => (
                <span  key={answer} className="w-100">
                  {userHasAnswered ? (
                    <span>
                      {userAnswer === answer ? (
                        <span>
                          {answer === correctAnswer ? (
                            <li className="Question-answer flex justify-start items-start lh-copy pv2 correct-color">
                              <Field disabled={userHasAnswered || submitting || submitSucceeded || submitFailed} className="correct-color" component="input" type="radio" name="answer" id={answer} value={answer} />
                              <label htmlFor={answer} className="b db pt1 correct-color">
                                {answer}
                                <i className="material-icons-inline correct-color pl2">check</i>
                              </label>
                            </li>
                          ) : (
                            <li key={answer} className="Question-answer flex justify-start items-start lh-copy pv2">
                              <Field disabled={userHasAnswered || submitting || submitSucceeded || submitFailed} className="incorrect-color" component="input" type="radio" name="answer" id={answer} value={answer} />
                              <label htmlFor={answer} className="w-90 b db pt1 incorrect-color">
                                {answer}
                                <i className="material-icons-inline incorrect-color pl2">close</i>
                              </label>
                            </li>
                          )}
                        </span>
                      ) : (
                        <span>
                          {answer === correctAnswer ? (
                            <li key={answer} className="Question-answer flex justify-start items-start lh-copy pv2 correct-color">
                              <Field disabled={userHasAnswered || submitting || submitSucceeded || submitFailed} className="correct-color" component="input" type="radio" name="answer" id={answer} value={answer} />
                              <label htmlFor={answer} className="w-90 b db pt1 correct-color">
                                {answer}
                                <i className="material-icons-inline correct-color pl2">check</i>
                              </label>
                            </li>
                          ) : (
                            <li key={answer} className="Question-answer flex justify-start items-start lh-copy pv2">
                              <Field disabled={userHasAnswered || submitting || submitSucceeded || submitFailed} component="input" type="radio" name="answer" id={answer} value={answer} />
                              <label htmlFor={answer} className="w-90 b db pt1">{answer}</label>
                            </li>
                          )}
                        </span>
                      )}
                    </span>
                  ) : (
                    <li key={answer} className="Question-answer flex justify-start items-start lh-copy pv2">
                      <Field disabled={userHasAnswered || submitting || submitSucceeded || submitFailed} component="input" type="radio" name="answer" id={answer} value={answer} />
                      <label htmlFor={answer} className="w-90 b db pt1">{answer}</label>
                    </li>
                  )}
                </span>
              ))}
            </ul>
            {!userHasAnswered && (
              <div className="w-100 mw7-ns tc center mt3 ph3">
                <Button disabled={!dirty || submitting} type="submit">Submit{submitting ? 'ting' : '' }</Button>
                <Link to={nextLinkTo} className="f7 moon-gray">Skip Question</Link>
              </div>
            )}
          </form>
        </div>
      </div>
    );
  }
}

QuestionForm.propTypes = {
  questionID: PropTypes.string.isRequired,
  question: PropTypes.shape({
    title: PropTypes.string.isRequired,
    answers: PropTypes.arrayOf(PropTypes.string).isRequired,
    correctAnswer: PropTypes.string.isRequired,
    successMessage: PropTypes.string.isRequired,
    userHasAnswered: PropTypes.bool.isRequired,
  }).isRequired,
  userAnswer: PropTypes.string.isRequired,
  questionNumber: PropTypes.number.isRequired,
  nextLinkTo: PropTypes.string.isRequired,
  sectionName: PropTypes.string.isRequired,
  showOfflineMessage: PropTypes.bool.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
    userAnswer: getUserAnswer(state, ownProps),
    answers: getAnswers(state),
    questionID: getQuestionID(state, ownProps),
    question: getQuestion(state, ownProps),
    initialState: {
      answer: '',
    },
    userUID: getUserUID(state),
    sectionIndex: getQuizSectionIndex(state, ownProps),
    quizID: getQuizID(state),
    quizSections: getQuizSections(state),
    questionNumber: getQuestionNumber(state, ownProps),
    sectionName: getSectionName(state, ownProps),
    nextLinkTo: getNextLinkTo(state, ownProps),
    numberOfQuestionsAnswered: currentUserNumberQuestionsAnswered(state, ownProps),
    totalNumberQuestions: totalNumberQuestions(state, ownProps),
  };
}


export default withRouter(connect(mapStateToProps)(QuestionForm));



// WEBPACK FOOTER //
// ./src/components/QuestionForm.js